import { getRuntimeVM } from "@u3u/vue-hooks/esm/util/runtime";
import { get } from "@/utils/lodash";

export function useUtils() {
  const vm = getRuntimeVM();
  const showMessage = function(message) {
    vm.$vux.toast.text(message);
  };
  const showError = function(err, type) {
    if (type) {
      vm.$vux.toast.show({
        text: err,
        type
      });
    } else {
      vm.$vux.toast.text(err);
    }
  };
  const showLoading = () => vm.$vux.loading.show();
  const hideLoading = () => vm.$vux.loading.hide();

  return { showMessage, showError, showLoading, hideLoading, get };
}

export function useApi(callback, loadingWrap) {
  const vm = getRuntimeVM();
  let next;

  if (loadingWrap && typeof loadingWrap.loading === "boolean") {
    loadingWrap.loading = true;
  }
  if (typeof callback === "function") {
    next = callback().catch(e => {
      vm.$showError(e);
      return Promise.reject(e);
    });
  } else if (callback instanceof Promise) {
    next = callback.catch(e => {
      vm.$showError(e);
      return Promise.reject(e);
    });
  } else {
    next = Promise.resolve();
  }
  if (loadingWrap && typeof loadingWrap.loading === "boolean") {
    next.finally(() => (loadingWrap.loading = false));
  }

  return next;
}
